<svg viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" {...$$restProps}>
	<circle cx="8" cy="8" r="8" fill="currentColor" />
	<path d="M11 5.14233L5.14213 11.0002" stroke="#FEFCF5" stroke-linecap="round" />
	<path d="M5.14209 5.14233L11 11.0002" stroke="#FEFCF5" stroke-linecap="round" />
</svg>
